import { Box } from '@mui/material';
import { getReportLanguage } from '../components/reportLanguageSelector';
import { ReportSectionComponentType } from '../types';
import { useReportUpdater } from '../hooks/useReportUpdater';
import EmptySectionWarning from '../components/emptySectionWarning';
import ReportPreviewButton from '../components/reportPreviewButton';
import StepFooter from '../../common/components/stepFooter';

/**
 * Report FNA step
 */
const FnaStep: ReportSectionComponentType = ({
  sectionName,
  report,
  onClickBack,
  onClickNext,
  isLoading: isSomethingLoading,
}) => {
  const { isLoading, saveChanges, sectionData } = useReportUpdater({ report, sectionName });

  const hasBuyAndSell = report.fnAs.some((fna) => fna.buyandsellParties.length > 0);
  const hasSuretyship = report.fnAs.some((fna) => fna.suretyshipParties.length > 0);
  const hasKeyperson = report.fnAs.some((fna) => fna.keypersonParties.length > 0);

  const handleClickNext = (): void => {
    saveChanges().then(() => onClickNext());
  };

  if (!sectionData) {
    return <EmptySectionWarning />;
  }

  return (
    <>
      <Box className="flex space-x-4">
        {hasKeyperson && (
          <ReportPreviewButton
            isLoading={isLoading}
            onClickPreview={saveChanges}
            reportId={report.id}
            sectionName={sectionName}
            language={getReportLanguage(report)}
            label="Preview Key person calculations"
            keyword="keyperson"
          />
        )}
        {hasSuretyship && (
          <ReportPreviewButton
            isLoading={isLoading}
            onClickPreview={saveChanges}
            reportId={report.id}
            sectionName={sectionName}
            language={getReportLanguage(report)}
            label="Preview Suretyship calculations"
            keyword="suretyship"
          />
        )}
        {hasBuyAndSell && (
          <ReportPreviewButton
            isLoading={isLoading}
            onClickPreview={saveChanges}
            reportId={report.id}
            sectionName={sectionName}
            language={getReportLanguage(report)}
            label="Preview Buy&Sell calculations"
            keyword="buyandsell"
          />
        )}
      </Box>
      <StepFooter
        isLoading={isLoading || isSomethingLoading}
        onClickBack={onClickBack}
        onClickNext={handleClickNext}
      />
    </>
  );
};

export default FnaStep;
